import { Distance } from '../../../../../FrontendBundle/Resources/js/ofcs';
import MoveItemsCommand from '../command/moveItemsCommand';
import CutangleItem from '../item/cutangleItem';
import DrillItem from '../item/drillItem';
import LengthUnitField from './lengthUnitField';

/**
 * @class LeftField
 */
export default class LeftField extends LengthUnitField {
    type = 'left';
    supports = 'supportsPositioning';

    /**
     * Update item with field value.
     *
     * @param {ItemInterface} item
     */
    updateValue(item) {
        const bounds = item.getBounds();
        const topLeft = bounds.getTopLeft();

        this.setValue(topLeft.x);
    }

    /**
     * Update field with item value.
     *
     * @param {ItemInterface} item
     */
    updateItem(item) {
        const value = this.getValue();
        const bounds = item.getBounds();
        const topLeft = bounds.getTopLeft();
        const difference = value - topLeft.x;
        const canvas = this.editor.getCanvas();
        const history = canvas.getHistory();

        this.assertItemValue(item, 'left', value);

        if (difference) {
            const command = new MoveItemsCommand(
                item,
                new Distance(difference, 0),
            );

            history.addAndExecuteCommand(command);
        }
    }

    /**
     * Update item with field value and apply a difference.
     *
     * @param {ItemInterface} item
     *
     * @param {number} difference
     */
    updateItemRelative(item, difference) {
        const canvas = this.editor.getCanvas();
        const history = canvas.getHistory();
        const command = new MoveItemsCommand(
            item,
            new Distance(difference, 0),
        );

        this.assertItemValue(item, 'left', item.get('position').x + difference);

        history.addAndExecuteCommand(command);
    }

    /**
     * Check if field is supportet by item.
     *
     * @param {ItemInterface} item
     * @param {number} selectionLength
     *
     * @return {boolean}
     */
    isSupported(item, selectionLength) {
        const supportFlag = this.supports;

        return selectionLength === 1
            && supportFlag
            && item
            && item[supportFlag]
            && !(item instanceof DrillItem)
            && !(item instanceof CutangleItem);
    }
}
